module.exports = __webpack_public_path__ + "img/month.f4acfad1.png";